// Copyright (c) StrangeBee 2024

import client from '@Client';
import { useGenericQuery } from '@Queries/genericQueries';
import { useCallback, useEffect, useState } from 'react';
import { BrandingParams } from 'thehive-sdk';

export interface UsePageTitleProps {
    title?: string;
    withPrefix?: boolean;
}

const usePageTitle = (title?: string, companyPrefix?: boolean): void => {
    const [companyName, setCompanyName] = useState<string>('TheHive');

    const { data: brandingData, status: brandingStatus } = useGenericQuery<BrandingParams>({
        fetchOnStart: true,
        manual: true,
        retry: false,
        key: ['branding-props'],
        fetchCallback: useCallback(() => client.BrandingController.list(), []),
    });

    useEffect(() => {
        if (brandingStatus === 'success') {
            if (!!brandingData?.title) {
                setCompanyName(brandingData.title);
            }
        }

        document.title = !!title ? (companyPrefix ? `${companyName} - ${title}` : title) : companyName;

        return () => {
            document.title = companyName;
        };
    }, [brandingData?.title, brandingStatus, companyName, title, companyPrefix]);
};

export default usePageTitle;
